import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LOGO from "../assets/images/logo.png";
import { GET } from "../components/CustomComponent";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top right, rgba(47, 213, 228, 0.20), transparent 32%), linear-gradient(160deg, #eef6f9 0%, #dbeaf1 55%, #edf7fb 100%)",
};

const cardStyle = {
  width: "100%",
  maxWidth: 520,
  background: "rgba(255,255,255,0.94)",
  border: "1px solid rgba(255,255,255,0.6)",
  borderRadius: 28,
  boxShadow: "0 28px 60px rgba(8, 46, 78, 0.14)",
};

const FILE_TYPE_META = {
  image: { icon: "fa-file-image", color: "#8d5cf6" },
  pdf: { icon: "fa-file-pdf", color: "#dc2626" },
  doc: { icon: "fa-file-word", color: "#0c75e6" },
  sheet: { icon: "fa-file-excel", color: "#188251" },
  slide: { icon: "fa-file-powerpoint", color: "#e2711d" },
  archive: { icon: "fa-file-zipper", color: "#b97007" },
  video: { icon: "fa-file-video", color: "#ef5da8" },
  audio: { icon: "fa-file-audio", color: "#0ea5e9" },
  text: { icon: "fa-file-lines", color: "#566575" },
  other: { icon: "fa-file", color: "#566575" },
};

const formatBytes = (bytes) => {
  const size = Number(bytes) || 0;
  if (size <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const index = Math.min(units.length - 1, Math.floor(Math.log(size) / Math.log(1024)));
  return `${(size / Math.pow(1024, index)).toFixed(index === 0 ? 0 : 1)} ${units[index]}`;
};

// หน้าเปิดไฟล์จากลิงก์แชร์ ไม่ต้องเข้าสู่ระบบ
export default function SharedFile() {
  const { token } = useParams();
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const loadFile = useCallback(async () => {
    setIsLoading(true);
    const result = await GET(`v1/public/shared-file/${token}`);
    if (result?.status && result.data) {
      setFile(result.data);
    } else {
      setError(result?.message || "ลิงก์ไม่ถูกต้องหรือหมดอายุแล้ว");
    }
    setIsLoading(false);
  }, [token]);

  useEffect(() => {
    loadFile();
  }, [loadFile]);

  const meta = FILE_TYPE_META[file?.file_type] || FILE_TYPE_META.other;

  return (
    <section className="d-flex align-items-center justify-content-center px-3 py-5" style={pageStyle}>
      <div className="p-4 p-md-5" style={cardStyle}>
        <div className="text-center mb-4">
          <img src={LOGO} alt="ParthenonTech" style={{ height: 48, objectFit: "contain" }} />
        </div>

        {isLoading ? (
          <div className="text-center text-secondary py-4">กำลังตรวจสอบลิงก์...</div>
        ) : error ? (
          <div className="text-center">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{ width: 64, height: 64, borderRadius: 20, background: "rgba(229, 83, 83, 0.14)", color: "#b63636", fontSize: 26 }}
            >
              <i className="fa-solid fa-link-slash" />
            </div>
            <div className="fw-bold mb-2" style={{ color: "#0b2c4c", fontSize: "1.2rem" }}>เปิดไฟล์นี้ไม่ได้</div>
            <div className="text-secondary small">{error}</div>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center gap-3 mb-4">
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{ width: 64, height: 64, borderRadius: 18, background: `${meta.color}1f`, color: meta.color, fontSize: 26 }}
              >
                <i className={`fa-solid ${meta.icon}`} />
              </div>
              <div className="text-truncate">
                <div className="fw-bold" style={{ color: "#0b2c4c", wordBreak: "break-word" }}>{file.name}</div>
                <div className="small text-secondary">{formatBytes(file.file_size)} · {file.mime_type || file.file_type}</div>
              </div>
            </div>

            {/* รูปกับ PDF ดูได้เลยในหน้านี้ ชนิดอื่นให้กดดาวน์โหลด */}
            {file.file_type === "image" && (
              <img src={file.url} alt={file.name} className="w-100 rounded-3 mb-4" style={{ maxHeight: 420, objectFit: "contain", background: "#f2f6fa" }} />
            )}
            {file.file_type === "pdf" && (
              <iframe title={file.name} src={file.url} className="w-100 rounded-3 mb-4" style={{ height: 420, border: "1px solid #e6edf5" }} />
            )}

            <a href={file.url} target="_blank" rel="noopener noreferrer" className="btn btn-primary w-100 fw-semibold py-3" style={{ borderRadius: 18 }}>
              <i className="fa-solid fa-download me-2" />ดาวน์โหลดไฟล์
            </a>
            <div className="small text-secondary text-center mt-3">ลิงก์ดาวน์โหลดมีอายุ 15 นาที ถ้าหมดอายุให้รีเฟรชหน้านี้อีกครั้ง</div>
          </>
        )}
      </div>
    </section>
  );
}
